export const IS_PRODUCTION = process.env.NEXT_PUBLIC_ENV === 'production'
export const SENTRY_DSN = process.env.NEXT_PUBLIC_SENTRY_DSN_URL
